"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAccountItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../../../utils/classFunctions");
const dateTime_1 = require("../../../../../utils/dateTime");
const roundMoney_1 = require("../../../../../utils/roundMoney");
const UserTypeIcon_1 = require("../../../../UserTypeIcon");
require("./index.scss");
const className = 'search-account-item';
const SearchAccountItem = (props) => {
    const { userType, name, birthday, balance, onClick, } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        birthday ? undefined : 'without-birthday',
    ]);
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement("div", { className: `${className}__title` },
            react_1.default.createElement("div", { className: `${className}__avatar` }, userType && (react_1.default.createElement(UserTypeIcon_1.UserTypeIcon, { userType: userType }))),
            react_1.default.createElement("div", { className: `${className}__name` }, name)),
        react_1.default.createElement("div", { className: `${className}__info` },
            birthday && (react_1.default.createElement("div", { className: `${className}__birthday` }, (0, dateTime_1.toInputDateString)(birthday))),
            react_1.default.createElement("div", { className: `${className}__balance` }, `${(0, roundMoney_1.localizeMoney)(balance, locale, 'Form/Field/SearchAccount/SearchAccountItem')} CHF`))));
};
exports.SearchAccountItem = SearchAccountItem;
//# sourceMappingURL=index.js.map